var exports = {
  "t": "ConnectedItem__fEJa3j",
};

module.exports = exports;
